// Vendor imports
const classNames = require('classnames')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')

const bem = BemEntity('IntoFooter')

function IntoFooter(props) {
  const currentYear = (new Date()).getUTCFullYear()
  return (
    tag('div', {
      className: classNames(
        props.className,
        bem.block()
      )
    },
      tag('div', {
        className: bem.element('container')
      },
        tag('div', {
          className: bem.element('item', 'menu')
        },
          tag('div', {
            className: bem.element('social-links')
          },
            tag('a', {
              className: bem.element('social', 'twitter'),
              href: 'https://twitter.com/getmixapp'
            }),
            tag('a', {
              className: bem.element('social', 'instagram'),
              href: 'https://instagram.com/getmixapp'
            })
          ),
          tag('div', {
            className: bem.element('menu-links')
          },
            tag('a', {
              className: bem.element('link'),
              href: 'mailto:support@mix.com'
            },
              'Contact'
            ),
            tag('a', {
              className: bem.element('link'),
              href: '/tos'
            },
              'Terms'
            ),
            tag('a', {
              className: bem.element('link'),
              href: '/privacy'
            },
              'Privacy'
            )
          )
        ),
        tag('div', {
          className: bem.element('item', 'company')
        },
          tag('div', {
            className: bem.element('copyrights')
          },
            `© ${currentYear} - Mix is an `,
            tag('a', {
              className: bem.element('expa'),
              href: 'https://expa.com'
            },
              'Expa'
            ),
            ` company`
          )
        )
      )
    )
  )
}

module.exports = IntoFooter
